<p-dialog 
  #dialog
  [header]="headerMessage"
  [(visible)]="showModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  (onHide)="onWindowHide()"
  [styleClass]="dialogClasses"
  [style]="{'width': '400px'}">

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="p-fluid flex flex-column gap-4">
    <!-- Username -->
    <p-floatLabel class="mt-4">
      <input pInputText
             id="username"
             formControlName="username"
             class="w-full"
             [attr.disabled]="isLoading">
      <label for="username">Username or Email</label>
    </p-floatLabel>

    <!-- Password -->
    <p-floatLabel class="mt-2">
      <p-password
             id="password"
             formControlName="password"
             styleClass="w-full"
       [style]="{'width': '100%'}"
       [inputStyle]="{'width': '100%'}"
             [feedback]="false"
             [disabled]="isLoading">
      </p-password>
      <label for="password">Password</label>
    </p-floatLabel>

    <!-- Submit -->
    <div class="flex justify-content-center">
      <button pButton
              type="submit"
              [label]="isLoading ? 'Logging in...' : 'Log in'"
              [loading]="isLoading"
              class="w-full"
              [disabled]="!loginForm.valid || isLoading">
      </button>
    </div>

    <!-- Links -->
    <div class="flex flex-column align-items-center gap-2">
      <a [routerLink]="'/password-reset'" (click)="onWindowHide()">
        Forgot your password?
      </a>
      <a [routerLink]="'/signup'" (click)="onWindowHide()">
        No account? Sign up
      </a>
    </div>

  </form>
</p-dialog>
